import { SegmentedControl } from "@/design-system/SegmentedControl/SegmentedControl";
import { useTranslation } from "@repo/shared/i18n";

type SortBy = "meta-rating" | "chemistry";

type Props = {
  sortBy: SortBy;
  onChange: (sortBy: SortBy) => void;
};

export const SortByMetaRatingOrChemistry = ({ sortBy, onChange }: Props) => {
  const { t } = useTranslation(["players", "common"]);
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="ml-3 text-xs text-foreground-body">
        {t("sortByLabel")}
      </span>
      {/* Compact, like the Gallery first-owner sheet's toggle */}
      <SegmentedControl
        label={t("sortByLabel")}
        track="page"
        className="h-8 p-0.5 [&>button]:px-3 [&>button]:py-1 [&>button]:text-xs [&>span]:inset-y-0.5"
        value={sortBy}
        onChange={onChange}
        options={[
          { value: "meta-rating", label: t("common:metaRating") },
          { value: "chemistry", label: t("common:chemistry") },
        ]}
      />
    </div>
  );
};
